// extracted by mini-css-extract-plugin
export default {"none":"mimic___styles_none__sTbGv","blurred":"mimic___styles_blurred__hN3KC","gradient":"mimic___styles_gradient__4bFi+"};